/**
 * Set targeting for a given key in Google Publisher Tag
 * @see {@link https://developers.google.com/publisher-tag/reference#googletag.PubAdsService_setTargeting}
 * @param key
 * @param values
 */
export function setGPTTargeting(key: string, values: string[]): void {
  if (typeof googletag === "undefined") {
    // See https://developers.google.com/publisher-tag/guides/get-started
    window.googletag = window.googletag || { cmd: [] };
  }

  googletag.cmd.push((): void => {
    googletag.pubads().setTargeting(key, values);
  });
}

/**
 * Remove targeting from a targeting slot in Google Publisher Tag
 * @param key The key of the targeting slot
 */
export function clearGPTTargeting(key: string): void {
  if (typeof googletag === "undefined") {
    // No need to clear the targeting if
    return;
  }
  googletag.cmd.push((): void => {
    googletag.pubads().clearTargeting(key);
  });
}
